export default __webpack_public_path__ + "static/media/product-2.66c7ad31.jpg";